import React from 'react'
import PropTypes from 'prop-types'
import * as Component from './styles'

import useOutsideClickHandler from 'hooks/outsideClickHandler'

const Autocomplete = (props) => {
  const { renderInput, renderOptions, hasError, ...rest } = props

  const autocomplete = React.useRef(null)
  const [show, setShow] = React.useState(true)

  React.useEffect(() => {
    if (hasError) setShow(true)
  }, [hasError])

  // close on outside click
  useOutsideClickHandler(autocomplete, () => {
    if (!hasError) {
      setShow(false)
    }
  })

  return (
    <Component.Root ref={ autocomplete } onClick={ () => setShow(true) }>
      {renderInput}
      {show && renderOptions && (
        <Component.OptionsContainer { ...rest }>
          {renderOptions}
        </Component.OptionsContainer>
      )}
    </Component.Root>
  )
}

Autocomplete.defaultProps = {
  hasError: false,
}

Autocomplete.propTypes = {
  /** Render the input */
  renderInput: PropTypes.node.isRequired,
  /** Render options */
  renderOptions: PropTypes.node,
  /** flag for error */
  hasError: PropTypes.bool,
}

export default Autocomplete
